import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import is from 'is_js';
import { Button, testClass } from 'omni-common-ui';
import ViewNav from 'components/ViewNav';
import LanguageSwitcher, { CHINESE_LANGUAGE } from 'components/LanguageSwitcher';
import Languages from 'domain/Languages';
import {
  SHOW_EXPORT_LANGUAGE,
} from '../IndividualDevelopmentPlanDetailView/exportFlags';
import styles from './style.postcss';

const EXPORT_LANGUAGES = [
  {
    code: CHINESE_LANGUAGE,
    label: '中文',
  },
  {
    code: Languages.defaultLanguageCode,
    label: 'EN',
  },
];

const isDetailView = (routes = []) => {
  const current = routes[routes.length - 1];
  return !!(current && current.path && current.path.indexOf('student/:studentId') !== -1);
};

const getCurrentRouteSegment = (routes) =>
  routes && routes.length ? routes[routes.length - 1] : {};

const getExportButtonDescriptor = (props) => {
  const currentRoute = getCurrentRouteSegment(props.routes);
  const currentModeName =
    props.params && props.params.mode && props.params.mode.length
      ? props.params.mode
      : 'default';
  const actionButtonsForMode =
    currentRoute.actionButtons && currentRoute.actionButtons[currentModeName];
  return actionButtonsForMode && actionButtonsForMode.Export;
};

const evaluateCondition = (condition, props, defaultValue) => {
  if (!is.function(condition)) {
    return defaultValue;
  }
  try {
    if (condition.length < 2) {
      return condition(props);
    }
    return condition(props.state, props);
  } catch (err) {
    return defaultValue;
  }
};

class ProgressReportHFv4ViewNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLanguage: Languages.defaultLanguageCode,
    };
    this._onLanguageChange = this._onLanguageChange.bind(this);
    this._onExportClick = this._onExportClick.bind(this);
  }

  _onLanguageChange(languageCode) {
    if (languageCode === CHINESE_LANGUAGE) {
      return;
    }
    this.setState({ selectedLanguage: languageCode });
  }

  _onExportClick() {
    const { push, buildRoute } = this.props;
    if (!is.function(push) || !is.function(buildRoute)) {
      return;
    }
    push(buildRoute('./export'));
  }

  _isExportVisible() {
    const exportButton = getExportButtonDescriptor(this.props);
    if (!exportButton) {
      return false;
    }
    return evaluateCondition(exportButton.visibleWhen, this.props, true);
  }

  _isExportDisabled() {
    const exportButton = getExportButtonDescriptor(this.props);
    if (!exportButton) {
      return true;
    }
    return evaluateCondition(exportButton.disableWhen, this.props, false);
  }

  _renderExportLanguageCluster() {
    if (!SHOW_EXPORT_LANGUAGE) {
      return null;
    }

    return (
      <div className={styles.DetailViewNav_rightCluster}>
        <LanguageSwitcher
          className={styles.DetailViewNav_languageSwitcher}
          languages={EXPORT_LANGUAGES}
          selectedLanguage={this.state.selectedLanguage}
          onLanguageChange={this._onLanguageChange}
        />
        {this._isExportVisible() && (
          <Button
            autoWidth
            type={Button.Type.default}
            disabled={this._isExportDisabled()}
            className={classnames(
              styles.DetailViewNav_exportButton,
              testClass('hfv4-viewnav-button-export')
            )}
            onClick={this._onExportClick}
          >
            Export
          </Button>
        )}
      </div>
    );
  }

  render() {
    if (!isDetailView(this.props.routes)) {
      return <ViewNav {...this.props} />;
    }

    return (
      <div
        className={classnames(styles.DetailViewNav, {
          [styles.__withExportLanguage]: SHOW_EXPORT_LANGUAGE,
        })}
      >
        <div className={styles.DetailViewNav_viewNav}>
          <ViewNav {...this.props} />
        </div>
        {this._renderExportLanguageCluster()}
      </div>
    );
  }
}

ProgressReportHFv4ViewNav.propTypes = {
  routes: PropTypes.array,
  params: PropTypes.object,
  state: PropTypes.object,
  push: PropTypes.func,
  buildRoute: PropTypes.func,
};

export default ProgressReportHFv4ViewNav;



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/ViewNav/index.jsx